import {Action} from '@ngrx/store';

/**
 * All actions of the spinner sub-store are described here
 * An action can have an optional payload
 */

export const UPDATE_LOADING = '[SPINNER] UPDATE_LOADING';

/**
 * The loading indicator is updated
 */
export class UpdateLoadingAction implements Action {
  readonly type = UPDATE_LOADING;

  constructor(public payload: boolean) {
  }
}

export type SpinnerAction = UpdateLoadingAction;
